import request from '../request.js'

//imeiUpdataList.vue
export function imeiUpdateList(params){
    return request({
        url: 'imeiUpdate/list.do?',
        method: 'post',
        data:params
    })
}

//单个新增
export function imeiUpdateSave(params){
    return request({
        url: 'imeiUpdate/save.do?',
        method: 'post',
        data:params
    })
}

//批量新增
export function batchImportSync(params){
    return request({
        url: 'imeiUpdate/batchImportSync.do?',
        method: 'post',
        data:params
    })
}

//单个删除
export function deleteImeiById(params){
    return request({
        url: 'imeiUpdate/deleteById.do?',
        method: 'post',
        data:params
    })
}

//批量删除
export function batchDeleteSync(params){
    return request({
        url: 'imeiUpdate/batchDeleteSync.do?',
        method: 'post',
        data:params
    })
}

// export function batchImportSync(params){
//     return request({
//         url: 'imeiWhitelist/batchImportSync.do?',
//         method: 'post',
//         data:params,
//         timeout:20000,
// 		headers:{'Content-Type': 'multipart/form-data'}
//     })
// }





